import React from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'

import { _IconWithValue, _PreviewIcon, _PreviewCopy } from './styles'

const IconWithValue = ({ svgSize, value, iconName, defaultValue = '-', svgReplacement }) => (
  <_IconWithValue>
    <_PreviewIcon className="previewIcon">
      {
        svgReplacement ||
        <SvgIcon
          name={'#icon-' + iconName}
          width={svgSize}
          height={svgSize}
        />
      }
    </_PreviewIcon>
    <_PreviewCopy className={'previewCopy'}>
      {value || defaultValue}
    </_PreviewCopy>
  </_IconWithValue>
)

IconWithValue.propTypes = {
  svgSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconName: PropTypes.string,
  svgReplacement: PropTypes.string,
}

export default IconWithValue

